import React from 'react'

import { Link } from 'react-router-dom'
import { Row, Col, Avatar, Divider, Card } from 'antd'

import {
  LAYOUT_FINANCE_INVOICE_CLIENT_LIST,
  LAYOUT_FINANCE_INVOICE_VENDOR_LIST,
  LAYOUT_FINANCE_PAYMENT_CLIENT_LIST,
  LAYOUT_FINANCE_PAYMENT_VENDOR_LIST,
  LAYOUT_FINANCE_PURCHASE_ORDER_LIST
} from '../navigation'

const { Meta } = Card

const InvoiceIcon = require('../../../assets/icons/invoice.png')
const AccountIcon = require('../../../assets/icons/account.png')
const PaymentIcon = require('../../../assets/icons/payment.png')

const Panel = (props) => (
  <>
    <Divider />

    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_FINANCE_INVOICE_CLIENT_LIST}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={InvoiceIcon} shape='square' />}
              title='Invoice'
              description='Client'
            />
          </Card>
        </Link>
      </Col>

      {/*
      <Col className="gutter-row" xs={24} md={12} lg={8} xl={6}>
          <Link to={LAYOUT_FINANCE_PANEL}>
              <Badge.Ribbon text="Coming soon!" color="grey">
                  <Card style={{ marginTop: 16 }} hoverable>
                      <Meta
                          avatar={<Avatar size="large" src={PaymentIcon} shape="square" />}
                          title="Payment"
                          description="Client"
                      />
                  </Card>
              </Badge.Ribbon>
          </Link>
      </Col>

      <Col className="gutter-row" xs={24} md={12} lg={8} xl={6}>
          <Link to={LAYOUT_FINANCE_PANEL}>
              <Badge.Ribbon text="Deprecated!" color="grey">
                  <Card style={{ marginTop: 16 }} hoverable>
                      <Meta
                          avatar={<Avatar size="large" src={InvoiceIcon} shape="square" />}
                          title="Purchase Order"
                          description="Client"
                      />
                  </Card>
              </Badge.Ribbon>
          </Link>
      </Col>
      <Col className="gutter-row" xs={24} md={12} lg={8} xl={6}>
          <Link to={LAYOUT_FINANCE_PANEL}>
              <Badge.Ribbon text="Coming soon!" color="grey">
                  <Card style={{ marginTop: 16 }} hoverable>
                      <Meta
                          avatar={<Avatar size="large" src={AccountIcon} shape="square" />}
                          title="Account"
                          description="Client"
                      />
                  </Card>
              </Badge.Ribbon>
          </Link>
      </Col>
      */}
    </Row>

    <Divider />

    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_FINANCE_PURCHASE_ORDER_LIST}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={InvoiceIcon} shape='square' />}
              title='Purchase Order'
              description='Vendor'
            />
          </Card>
        </Link>
      </Col>
      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_FINANCE_INVOICE_VENDOR_LIST}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={InvoiceIcon} shape='square' />}
              title='Invoice'
              description='Vendor'
            />
          </Card>
        </Link>
      </Col>

      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_FINANCE_PAYMENT_VENDOR_LIST}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={PaymentIcon} shape='square' />}
              title='Payment'
              description='Vendor'
            />
          </Card>
        </Link>
      </Col>

      {/*
      <Col className="gutter-row" xs={24} md={12} lg={8} xl={6}>
          <Link to={LAYOUT_FINANCE_PANEL}>
              <Badge.Ribbon text="Coming soon!" color="grey">
                  <Card style={{ marginTop: 16 }} hoverable>
                      <Meta
                          avatar={<Avatar size="large" src={AccountIcon} shape="square" />}
                          title="Account"
                          description="Vendor"
                      />
                  </Card>
              </Badge.Ribbon>
          </Link>
      </Col>
      */}
    </Row>
  </>
)

export default Panel
